__webpack_require__.p = "/in/obi/";